import * as ActionTypes from '../actions'

const initialState = {
    items: false,
    data: false,
    isLoading: false,
    processingOrder: false,
    processingSuccess: false,
    processingError: false
};

const Cart = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_CART_REQUEST:
            return { ...state, isLoading: true};

        case ActionTypes.FETCH_CART_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items, data: action.payload.data};

        case ActionTypes.FETCH_CART_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.ADD_ITEM_REQUEST:
            return { ...state, isLoading: false};

        case ActionTypes.ADD_ITEM_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items};

        case ActionTypes.ADD_ITEM_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.REMOVE_ITEM_REQUEST:
            const itemsToRemove = {...state.items};
            delete itemsToRemove[action.identifier];
            return { ...state, isLoading: false, items: itemsToRemove};

        case ActionTypes.REMOVE_ITEM_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items};

        case ActionTypes.REMOVE_ITEM_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.UPDATE_DATA_REQUEST:
            return { ...state, isLoading: true};

        case ActionTypes.UPDATE_DATA_SUCCESS:
            return { ...state, isLoading: false, data: action.payload.data};

        case ActionTypes.UPDATE_DATA_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.ADD_PARTICIPANT_TO_ITEM_REQUEST:
            const itemsToAddParticipant = {...state.items};
            itemsToAddParticipant[action.identifier].participants['new'] = action.participant;
            return { ...state, isLoading: false, items: itemsToAddParticipant}

        case ActionTypes.ADD_PARTICIPANT_TO_ITEM_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items};

        case ActionTypes.ADD_PARTICIPANT_TO_ITEM_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.UPDATE_PARTICIPANT_FOR_ITEM_REQUEST:
            return { ...state, isLoading: false};

        case ActionTypes.UPDATE_PARTICIPANT_FOR_ITEM_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items};

        case ActionTypes.UPDATE_PARTICIPANT_FOR_ITEM_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.REMOVE_PARTICIPANT_FROM_ITEM_REQUEST:
            const itemsToRemoveParticipant = {...state.items};
            delete itemsToRemoveParticipant[action.itemIdentifier].participants[action.identifier];
            return { ...state, isLoading: false, items: itemsToRemoveParticipant};

        case ActionTypes.REMOVE_PARTICIPANT_FROM_ITEM_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items};

        case ActionTypes.REMOVE_PARTICIPANT_FROM_ITEM_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.UPLOAD_FILE_TO_PARTICIPANT_REQUEST:
            return { ...state, isLoading: false};

        case ActionTypes.UPLOAD_FILE_TO_PARTICIPANT_SUCCESS:
            return { ...state, isLoading: false, items: action.payload.items};

        case ActionTypes.UPLOAD_FILE_TO_PARTICIPANT_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.UPLOAD_FILE_TO_DATA_REQUEST:
            return { ...state, isLoading: false};

        case ActionTypes.UPLOAD_FILE_TO_DATA_SUCCESS:
            return { ...state, isLoading: false, data: action.payload.data};

        case ActionTypes.UPLOAD_FILE_TO_DATA_FAILURE:
            return { ...state, isLoading: false}

        case ActionTypes.PROCESS_ORDER_REQUEST:
            return { ...state, isLoading: true};

        case ActionTypes.PROCESS_ORDER_SUCCESS:
            return { ...state, isLoading: false, processingSuccess: action.payload.success, processingError: action.payload.error};

        case ActionTypes.PROCESS_ORDER_FAILURE:
            return { ...state, isLoading: false, processingSuccess: false, processingError: true}

        case ActionTypes.FLUSH_ALL:
            return {
                items: false,
                data: false,
                isLoading: false,
                processingSuccess: false,
                processingError: false
            };

        default:
            return state;
    }
};

export default Cart;
